import { NgOptimizedImage, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { LANGUAGES } from "@constants/app.constants";
import { PartnerDbModel } from '@data-models/partner-db.model';
import { ImgFallbackDirective } from '@directives/img-fallback.directive';
import { environment } from '@env/environment';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BrokenImageHandlerPipe } from '@pipes/broken-image-handler.pipe';
import { PartnerService } from '@services/feature-service/partner.service';
import { HelperService } from '@services/helper/helper.service';
import { DomManipulationService } from '@services/util-service/dom-manipulation.service';

@Component({
  selector: 'app-calio-header',
  templateUrl: './calio-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, MatMenuModule, MatButtonModule, TranslateModule, TitleCasePipe, NgOptimizedImage, ImgFallbackDirective, BrokenImageHandlerPipe]
})
export class CalioHeaderComponent implements OnInit {

  readonly deployUrl = environment.deployUrl;
  readonly landingPageImagePath = environment.landingPageImagePath;
  readonly partnersImagePath = environment.partnersImagePath;
  readonly languages = LANGUAGES;
  readonly brandFolder = environment.brandFolder;

  private partnerService = inject(PartnerService);
  private translate = inject(TranslateService);
  private helperService = inject(HelperService);
  private domManipulationService = inject(DomManipulationService);
  protected partnerLoadEvent$: any;

  protected supportedLanguages = signal<string[]>([]);
  protected lang = signal<string>(null);
  protected partner = signal<PartnerDbModel>(null);
  protected logo = signal<string>(null);
  protected internal = signal(false);
  protected isIframe = signal(false);

  ngOnInit() {
    this.isIframe.set(this.helperService.isIframe());

    this.partnerLoadEvent$ = this.partnerService.partnerLoadEvent.subscribe(partner => {
      if (partner?.uuid && partner?.has_active_subscription) {
        this.partner.set(partner);
        this.internal.set(this.partnerService.isInternal);
        this.supportedLanguages.set(this.partner().supported_widget_languages);

        if (this.partnerService.isWhitelabeledPartner) {
          if (this.partner()?.landingpage_logo) {
            this.logo.set(`${this.landingPageImagePath}${this.partner().uuid}/${this.partner().landingpage_logo}`);
          } else if (this.partner()?.logo) {
            this.logo.set(`${this.partnersImagePath}${this.partner().uuid}/${this.partner().logo}`);
          }
        }
      } else {
        this.supportedLanguages.set([this.helperService.getDefaultLanguage()]);
      }

      if (!this.logo()) {
        this.logo.set('/images/brands/' + environment.brandFolder + '/logo.svg');
      }

      this.lang.set(this.translate.getFallbackLang());
      this.partnerLoadEvent$.unsubscribe();
    });
  }

  switchLanguage(language: string): void {
    this.lang.set(language);
    this.translate.use(language);
    this.translate.setFallbackLang(language);
    // The copy changes language without a navigation, so nothing else would update the
    // document's own declaration of it.
    this.domManipulationService.setDocumentLanguage(language);
  }
}
